import { render, staticRenderFns } from "./AlternativeLoginButtons.vue?vue&type=template&id=29aa909c&scoped=true&"
import script from "./AlternativeLoginButtons.vue?vue&type=script&lang=js&"
export * from "./AlternativeLoginButtons.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeLoginButtons.vue?vue&type=style&index=0&id=29aa909c&prod&scoped=true&lang=css&"
import style1 from "./AlternativeLoginButtons.vue?vue&type=style&index=1&id=29aa909c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa909c",
  null
  
)

export default component.exports